import type { ApiError, CreateRoomRequest, CreateRoomResponse, JoinRoomRequest, JoinRoomResponse, RoomInfoResponse } from '@shared/types/api';

export class ApiRequestError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: ApiError['error'],
    message: string,
    public readonly field?: string,
  ) {
    super(message);
    this.name = 'ApiRequestError';
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  let response: Response;
  try {
    response = await fetch(path, {
      ...init,
      headers: { 'Content-Type': 'application/json', ...(init?.headers ?? {}) },
    });
  } catch {
    throw new ApiRequestError(0, 'INTERNAL_ERROR', '인터넷 연결을 확인해주세요.');
  }
  const text = await response.text();
  let body: unknown = null;
  try {
    body = text ? JSON.parse(text) : null;
  } catch {
    body = null;
  }
  if (!response.ok) {
    const err = (body ?? {}) as Partial<ApiError>;
    throw new ApiRequestError(response.status, err.error ?? 'INTERNAL_ERROR', err.message ?? '일시적인 오류가 발생했어요.', err.field);
  }
  return body as T;
}

export const api = {
  createRoom: (body: CreateRoomRequest) => request<CreateRoomResponse>('/api/rooms', { method: 'POST', body: JSON.stringify(body) }),
  getRoomInfo: (roomId: string) => request<RoomInfoResponse>(`/api/rooms/${encodeURIComponent(roomId)}`),
  joinRoom: (roomId: string, body: JoinRoomRequest) =>
    request<JoinRoomResponse>(`/api/rooms/${encodeURIComponent(roomId)}/join`, { method: 'POST', body: JSON.stringify(body) }),
};
